import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitlePositioner } from '@shared/general';
import { TextLabel } from '@lib/ui-components';
import { CompanyContactPersonsTable } from '../../../../company-contact-persons-table';
import { ContactPersonTypeEnum } from '../../../../../../../../../libs/api-interface/models/company/contact-person-type.enum';
import { useCompanyBranchContext } from '../../../../../../../../../contexts/company-branch.context';

export const CompanyBranchOrganizations = () => {
  const { t } = useTranslation();
  const companyBranch = useCompanyBranchContext();

  return (
    <>
      <TitlePositioner>
        <TextLabel label={t('customerKeepers')} />
      </TitlePositioner>
      <CompanyContactPersonsTable companyId={companyBranch.companyId!} branchId={companyBranch.branchId} type={ContactPersonTypeEnum.ORGANIZATION} />
    </>
  );
};
